import { render, staticRenderFns } from "./bannerCreate.vue?vue&type=template&id=d10404a0&scoped=true&lang=html"
import script from "./bannerCreate.vue?vue&type=script&lang=js"
export * from "./bannerCreate.vue?vue&type=script&lang=js"
import style0 from "./bannerCreate.vue?vue&type=style&index=0&id=d10404a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10404a0",
  null
  
)

export default component.exports